import {OptionAttribute} from "../../data";
import {stateSelectedComplectations} from "../../data/atoms";
import {useRecoilValue} from "recoil";

export const useFilteredVariants = (optionAttributes: OptionAttribute[]) => {
    const optionsSelected = useRecoilValue(stateSelectedComplectations);
    const optionsSelectedKeys = Object.keys(optionsSelected);


    return optionAttributes.filter(optionAttribute => {
        if (!optionsSelectedKeys.length) {
            return true;
        }

        const optionDependencies = optionAttribute.dependencies;

        if (optionDependencies) {
            const dependencyKeys = optionDependencies && Object.keys(optionDependencies);

            return dependencyKeys.every((key) => {
                const value = optionsSelected[key]?.id || null;
                const hasKey = optionsSelected.hasOwnProperty(key);
                const hasValue = value && optionDependencies[key].includes(value);

                return !hasKey || (hasKey && hasValue);
            });
        }

        return true;
    });
};
